import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as tourActions from './../../../../actions/tourAction';
import Tours from './Tours';

const mapStateToProps = state => {
    return {
        tourState: state.tourReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListTours: (params) => dispatch(tourActions.getListTours(params)),
        deleteTour: (tour, refreshParams) => dispatch(tourActions.deleteTour(tour, refreshParams)),
        exportExcel: (params) => dispatch(tourActions.exportExcel(params)),
        cloneTour: (id, lengthOfStay, isCopyTourTickets, refreshParams) => dispatch(tourActions.cloneTourAction(id, lengthOfStay, isCopyTourTickets, refreshParams))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Tours));
